import ym from 'react-yandex-metrika';
import qs from 'query-string';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';

import { useGeneratePath, useStaticUrls } from 'platform-components';
import { getExactPathMatch } from 'platform-components/utils';
import { getUserId } from 'platform-components/src/components/user/selectors';
import { useCallback } from 'react';

export const useChangeGrade = () => {
    const history = useHistory();
    const { pathname, search } = useLocation();
    const query = qs.parse(search);
    const userId = useSelector(getUserId);
    const staticUrls = useStaticUrls();
    const getRouterPath = useGeneratePath();

    return useCallback(
        (grade: number, { isReplace }: { isReplace?: boolean } = {}) => {
            ym('reachGoal', 'teacher_main_change_grade', { grade, user_id: userId || null });

            const { path = '' } = getExactPathMatch(staticUrls, pathname) || {};
            let newPathname = pathname;
            if (path === staticUrls.labLibrarySubjectCommonCourseContainer) {
                newPathname = getRouterPath(staticUrls.deepLabLibrary);
            }

            const newQuery = qs.stringify({ ...query, grade });
            if (isReplace) {
                history.replace(`${newPathname}?${newQuery}`);
            } else {
                history.push(`${newPathname}?${newQuery}`);
            }
        },
        [getRouterPath, history, pathname, query, staticUrls, userId]
    );
};
